import { observable } from "@legendapp/state";

/** Brief message shown in the document (sidebar) pane after a linked clip. */
export const clipLinkFeedback$ = observable({
  message: null as string | null,
});
